import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, QueryList, ViewChildren } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkHistoryService, WorkHistory } from '../../services/work-history.service';
import {
  TextInputComponent,
  SelectInputComponent,
  DateInputComponent,
  SelectOption,
  PhoneMaskDirective,
  CheckboxComponent,
  TextAreaComponent,
  RadioComponent,
  dateNotInFutureValidator
} from 'ddmo-storybook-lib';
import { FormControl } from '@angular/forms';
import { LABELS } from '../../../../shared/constants/lables.constants';
import { of, tap } from 'rxjs';
import { LoaderService } from '../../../../shared/services/loader.service';
import $ from 'jquery';
interface WorkHistoryDTO {
  workHistoryId: number | null;
  credentialingEventId: number | string | null;
  userId: number | null;
  organizationName: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  phone: string | null;
  startDate: string | null;
  endDate: string | null;
  gapExplanation?: string | null;
  isSchool?: boolean;
  isDeleted?: boolean;
  isLocationInDW?: boolean;
  other?: string | null;
  isCurrentlyWorking?: any |null
}

@Component({
  selector: 'app-work-history-form',
  imports: [CommonModule, ReactiveFormsModule, CommonModule,
    ReactiveFormsModule,
    TextInputComponent,
    TextAreaComponent,
    SelectInputComponent,
    DateInputComponent,
    RadioComponent,
    PhoneMaskDirective, CheckboxComponent],
  templateUrl: './work-history-form.component.html',
  styleUrl: './work-history-form.component.scss'
})


export class WorkHistoryFormComponent implements OnInit {
  private gapBackup: any = {};
  checkForm!: FormGroup;
  stillWorkingForm!: FormGroup;
  form: FormGroup;
  isEditMode = false;
  today: any = new Date();
  minDate = new Date();
  get hasGapsGroup(): FormGroup {
    return this.fb.group({
      hasGaps: this.form.get('hasGaps')
    })
  }
  gapOptions = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' }
  ]

  editId: any | null = null;
  checkboxLabel: any =
    'Indicate if this is education';
  stateOptions: SelectOption[] = LABELS.STATE_CODES_LIST
  options: SelectOption[] = [
    { value: "ABC", viewValue: 'ABC hospital' }
  ]

  customErrorMessagesZip = { minlength: LABELS.ERROR_MESSAGES.minimumFiveCharecter, required: 'Required' };
  customErrorMessagesOrgandAddress = { maxlength: LABELS.ERROR_MESSAGES.maxAddressAndName, required: 'Required' };
  customErrorMessagesCity = { maxlength: LABELS.ERROR_MESSAGES.maxCity, required: 'Required' };
  customErrorMessagesCountry = { maxlength: LABELS.ERROR_MESSAGES.maxCity};
  customErrorMessageEnddate = { endBeforeStart: 'The End date cannot be before the Start date', required: 'Required',dateInFuture: 'End date cannot be in the future'}
customErrorMessageStartdate = { startBeforelimit: 'The selected date cannot be earlier than 5 years from today', required: 'Required',dateInFuture: 'Start date cannot be in the future'}
  PHONE_PATTERN = LABELS.PHONE_PATTERN;
  private datapipe = new DatePipe('en-US')
  get fc(): { [key: string]: FormControl } {
    return this.form.controls as any;
  }
  isViewOnly = false;
  gapExplanationBackUp: any = '';
  selectedSchoolFromDropDown: any = '';
  impersonatedUser: any = localStorage.getItem("impersonatedUser") ?? ""
  isEducationChecked = false;
  showFulladdressError = false
  private endDateAfterStartValidator: any = (control: FormControl) => {

    const start = this.form?.get('startDate')?.value;
    const end = control.value;

    if (!start || !end) return null;

    const startDate = new Date(start);
    const endDate = new Date(end);

    return endDate < startDate
      ? { endBeforeStart: true }
      : null;
  };

  private startDateYearLimitValidator: any = (control: FormControl) => {

    const start = control.value;

    if (!start) return null;

    const startDate = new Date(start);


    startDate.setHours(0, 0, 0, 0);
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 5);
    minDate.setHours(0, 0, 0, 0);
    return startDate < minDate
      ? { startBeforelimit: true }
      : null;
  };
  schoolsList: any = [];
  schoolBackup: any = null;
  FIELD_LIMITS: any = {
    organizationName: { type: 'string', maxLength: 255 },
    other: { type: 'string', maxLength: 255 },
    location: { type: 'string', maxLength: 255 },
    address2: { type: 'string', maxLength: 255 },
    city: { type: 'string', maxLength: 150 },
    zip: { type: 'string', maxLength: 5 },
    phone: { type: 'string', maxLength: 14 },
  }
  showError: boolean = false;
  suggestionCount: any = 0;
  private scrollHandler = this.onScroll.bind(this);
  selectedAddress: any = '';
  isPlaceSelected: boolean = false;
  degreeOptions: SelectOption[] = [
    { value: "DDS", viewValue: "DDS" },
    { value: "MD", viewValue: "MD" },
    { value: "DMD", viewValue: "DMD" },]  
    educationTypeOptions: SelectOption[] = [
      { value: "DENTAL_SCHOOL", viewValue: "Dental school" },
      { value: "OTHER", viewValue: "Other" },
      { value: "SPECIALITY_TRAINING", viewValue: "Speciality training" },
      { value: "UNDERGRADUATE", viewValue: "Undergraduate" },
    ] 
  @ViewChildren('locationInput') locationInputs!: QueryList<ElementRef>;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private workHistoryService: WorkHistoryService,
    private loader: LoaderService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {
    this.form = this.fb.group({
      organizationName: ['', [Validators.required, Validators.maxLength(255)]],
      other: [{ value: '', disabled: true }],
      location: ['', Validators.maxLength(255)],
      address2: ['', Validators.maxLength(255)],
      city: ['', Validators.maxLength(150)],
      state: [''],
      zip: new FormControl('', [Validators.minLength(5), Validators.maxLength(5)]),
      country: new FormControl('',Validators.maxLength(150)),
      phone: new FormControl('', [Validators.pattern(this.PHONE_PATTERN)]),
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      hasGaps: ['false'],
      gapExplanation: [''],
      degree:new FormControl(''),
      educationType:new FormControl( 'DENTAL_SCHOOL'),
    });


    this.form.get('endDate')?.addValidators(this.endDateAfterStartValidator);
    this.form.get('endDate')?.addValidators(dateNotInFutureValidator);
    this.form.get('startDate')?.addValidators(dateNotInFutureValidator);
    this.form.get('startDate')?.updateValueAndValidity();
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loader.show();
    this.getSchools();
    this.minDate.setFullYear(this.today.getFullYear() - 5)
    this.route.queryParams.subscribe(params => {
      if (params['viewOnly'] === 'true' || params['viewOnly'] === true) {
        this.isViewOnly = true;
      }
    })
    this.checkForm = this.fb.group({
      educationChecked: [false],
    });
    this.stillWorkingForm = this.fb.group({
      workingChecked: [false],
    });

    this.form.get('hasGaps')?.valueChanges.subscribe(value => {
      const hasGap = value === 'true' || value === true;
      if (this.isViewOnly) { return };
      const gapCtrl = this.form.get('gapExplanation');
      const startDateCtrl = this.form.get('startDate');
      const endDateCtrl = this.form.get('endDate');
      if (hasGap === true) {
        gapCtrl?.setValue(this.gapExplanationBackUp);
        gapCtrl?.setValidators([Validators.required]);
        startDateCtrl?.setValidators([Validators.required, dateNotInFutureValidator]);
        endDateCtrl?.setValidators([Validators.required, dateNotInFutureValidator]);
      } else {

        this.gapExplanationBackUp = gapCtrl?.value || '';
        gapCtrl?.clearValidators();
        const orgName: any = this.form.getRawValue().organizationName;
      }

      gapCtrl?.updateValueAndValidity();
      startDateCtrl?.updateValueAndValidity();
      endDateCtrl?.updateValueAndValidity();


      const disableFields = ['organizationName', 'other', 'location', 'city', 'state', 'zip', 'phone','country','degree','educationType'];

      if (hasGap) {
        if (this.checkForm.get('educationChecked')?.value) {
          this.schoolBackup = this.form.get('organizationName')?.value;
        }
        this.checkForm.get('educationChecked')?.disable();
        disableFields.forEach(f => {
          this.gapBackup[f] = this.form.get(f)?.value;
          this.form.get(f)?.setValue(null);
          this.form.get(f)?.disable();
        })
      }
      else {
        this.checkForm.get('educationChecked')?.enable();
        disableFields.forEach(f => {
          this.form.get(f)?.enable();
          this.form.get(f)?.setValue(this.gapBackup[f] || '');
        });
        this.form.get('other')?.disable();
        if (this.checkForm.get('educationChecked')?.value) {
          if (this.schoolBackup) {
            this.form.get('organizationName')?.setValue(this.schoolBackup)
          }
        }
        else {
          this.form.get('organizationName')?.setValue(this.gapBackup['organizationName'] || '')
        }

        const orgSelectedId = this.form.getRawValue().organizationName;
        if (orgSelectedId == 1) {
          this.form.get('other')?.enable();
          this.form.get('other')?.addValidators(Validators.required)
          this.form.get('other')?.updateValueAndValidity();
        }
        else {
          this.form.get('other')?.disable();
          this.form.get('other')?.removeValidators(Validators.required)
          this.form.get('other')?.updateValueAndValidity();
        }
      }
      this.form.get('startDate')?.valueChanges.subscribe(start => {

        const endCtrl = this.form.get('endDate');

        if (!start || !endCtrl?.value) return;

        const startDate = new Date(start);
        const endDate = new Date(endCtrl.value);


        if (endDate < startDate) {
          endCtrl.setValue(null);
        }

        endCtrl.updateValueAndValidity();
      });
    });
    this.listenPhoneFormat();
    this.route.params.subscribe(params => {
      this.editId = params['id'] || null;
      this.isEditMode = !!this.editId;
    });


    const histories = localStorage.getItem('workhistories') ? JSON.parse(localStorage.getItem('workhistories') || '[]') : [];
    if (this.isEditMode && this.editId) {
      const history: any = histories.find(
        (h:any )=> h.workHistoryId == this.editId
      );
      if (history) {
        this.form.patchValue({ history });
        this.form.patchValue({
          "location" :  history.address1 ? history.address1 : ""
        })
        if (this.isViewOnly) {
          this.form.disable()
          this.checkForm.disable();
        };
      }
      if (history?.gapExplanation && history.gapExplanation.trim() !== '') {
        this.form.get('hasGaps')?.setValue('true');
        this.form.patchValue({ history });
        this.form.patchValue({
          "location" :  history.address1 ? history.address1 : ""
        })
      }
      else {
        this.form.get('hasGaps')?.setValue('false');
        this.form.patchValue({ history });
        this.form.patchValue({
          "location" :  history.address1 ? history.address1 : ""
        })
      }
      this.form.get('gapExplanation')?.setValue(history.gapExplanation);
      this.form.get('startDate')?.setValue(history.startDate ? new Date(history.startDate) : null)
      this.form.get('endDate')?.setValue(history.endDate ? new Date(history.endDate) : null)
      if (history?.isSchool) {
        this.checkForm.get('educationChecked')?.setValue(true, { emitEvent: false });
        this.isEducationChecked = false;
        this.loader.show()
        const schools = JSON.parse(localStorage.getItem('schoolswithAddresses') || '[]');
        this.schoolsList = this.formatDropDown(schools);
        if (this.schoolsList && this.schoolsList.length > 0) {
          const matchedOption = this.schoolsList.find((o: any) => o.viewValue == history.organizationName);
          if (matchedOption) {
            setTimeout(() => {
              this.form.get('organizationName')?.setValue(matchedOption.value);
              this.form.get('other')?.setValue(history.other)
              this.onSchoolChange({ value: matchedOption.value, viewValue: matchedOption.viewValue });
              this.isEducationChecked = true;
              this.loader.hide();
              this.cdr.detectChanges();
            })
            if (matchedOption.viewValue == "My School Is Not Listed") {
              this.form.get('other')?.enable();
              this.form.get('other')?.setValue(history.other)
            }
            else {
              this.form.get('other')?.disable();
            }
          }
          else {
            this.isEducationChecked = true;
            this.loader.hide();
            this.cdr.detectChanges();
          }
        }
      }
      else {
        this.checkForm.get('educationChecked')?.setValue(false, { emitEvent: false });
        this.isEducationChecked = false;
        this.selectedSchoolFromDropDown = '';

        const notlisted = this.schoolsList.find((o: any) => o.viewValue == "My School Is Not Listed");
        this.form.get('organizationName')?.setValue(notlisted?.value);
        this.form.get('other')?.enable();
        this.form.get('other')?.setValue(history.other);
      }   
      if(!this.checkForm.get('educationChecked')?.value&&
      !(this.form.get('hasGaps')?.value === 'true' || this.form.get('hasGaps')?.value === true)){
        this.stillWorkingForm.patchValue({
          workingChecked : history?.isCurrentlyWorking
        })
        if(history?.isCurrentlyWorking){
          this.form.get('endDate')?.removeValidators(Validators.required)
          this.form.get('endDate')?.updateValueAndValidity();
        }
      }   
    }
    const disableFields = ['organizationName', 'location', 'city', 'state', 'zip', 'phone','country','degree','educationType'];
    if (this.form.get('hasGaps')?.value === true || this.form.get('hasGaps')?.value === 'true') {
      disableFields.forEach(f => {
        this.gapBackup[f] = this.form.get(f)?.value;
        this.form.get(f)?.setValue(null);
        this.form.get(f)?.disable();
      });
    } else {
      disableFields.forEach(f => {
        this.form.get(f)?.enable();
      });
      if (this.isEditMode) {
        this.loadWorkHistory(this.editId); 
      }
    }
    this.form.get('startDate')?.valueChanges.subscribe(start => {

      const endCtrl = this.form.get('endDate');

      if (!start || !endCtrl?.value) return;

      const startDate = new Date(start);
      const endDate = new Date(endCtrl.value);


      if (endDate < startDate) {
        endCtrl.setValue(null);
      }

      endCtrl.updateValueAndValidity();
    });

    this.checkForm.get('educationChecked')?.valueChanges.subscribe(eduChecked => {
      const orgCtrl = this.form.get('organizationName');
      if (!orgCtrl) return;

      if (!eduChecked) {

        this.isEducationChecked = false;
        const selectedValue = orgCtrl.value;
        const matched = this.schoolsList.find((o: { value: any; }) => o.value == selectedValue);
        if (matched) {
          orgCtrl.setValue(matched.viewValue);
        }
        if(this.stillWorkingForm.get('workingChecked')?.value == true){
          this.form.get('endDate')?.removeValidators(Validators.required)
        }
        this.loader.hide();  

      } else {
        this.loader.show();
        this.isEducationChecked = false;
        this.cdr.detectChanges();

        const textVal = orgCtrl.value;
        this.form.get('endDate')?.setValidators(Validators.required)

        setTimeout(() => {
          if (this.schoolsList && this.schoolsList.length > 0) {
            const matched = this.schoolsList.find((o: { viewValue: any; }) => o.viewValue == textVal);
            if (matched) {
              orgCtrl.setValue(matched.value);
            } else {

            }
            this.isEducationChecked = true;
            this.loader.hide();
            this.cdr.detectChanges();

          } else {

            const interval = setInterval(() => {
              if (this.schoolsList && this.schoolsList.length > 0) {
                clearInterval(interval);
                const matched = this.schoolsList.find((o: { viewValue: any; }) => o.viewValue == textVal);
                if (matched) {
                  orgCtrl.setValue(matched.value);
                }
                this.isEducationChecked = true;
                this.loader.hide();           
                this.cdr.detectChanges();
              }
            }, 100);


            setTimeout(() => {
              clearInterval(interval);
              this.isEducationChecked = true;
              this.loader.hide();
            }, 5000);
          }
        }, 50);
      }
      this.form.get('endDate')?.updateValueAndValidity();
    });
   
    if (this.impersonatedUser) {
      this.form.disable({ emitEvent: false });
      this.checkForm.disable();
    }
  }

  restrictNonNumeric(event: KeyboardEvent) {
    const char = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(char)) {
      event.preventDefault();
    }
  }

  loadWorkHistory(id: string) {
    const histories = localStorage.getItem('workhistories') ? JSON.parse(localStorage.getItem('workhistories') || '[]') : [];
    const history = histories.find((h:any )=> h.workHistoryId == id);
    if (history) {
      this.form.patchValue(history);
      this.form.patchValue({
        "location" :  history.address1 ? history.address1 : ""
      })
    }
    if (this.form.getRawValue().organizationName?.toLowerCase() == "gap in work history") {
      this.form.get('organizationName')?.setValue('');
    }
  }

  onCancel() {
    this.router.navigate(['/credentialing/work-history']);
  }

  onReset(){
    this.form.reset();
    this.loadData();
    this.form.get('hasGaps')?.setValue(
      this.form.get('hasGaps')?.value ?? "false"
    );
    this.cdr.detectChanges();
  }

  onSave() {
    if (!this.form.valid) {
      Object.values(this.form.controls).forEach((c: any) => c.markAsTouched());
      return;
    }

    const f = this.form.getRawValue();

    const credentialingEventId = Number(localStorage.getItem('credentialingEventId'));
    const userId = Number(localStorage.getItem('user_id'));

    let organizationName = f.organizationName;

    // Handle School Dropdown
    if (this.checkForm.get('educationChecked')?.value) {

      if (this.selectedSchoolFromDropDown) {

        // User selected new school
        organizationName = this.selectedSchoolFromDropDown;

      } else {

        // Editing existing school record
        const matched = this.schoolsList.find(
          (s: any) => s.value == f.organizationName
        );

        organizationName = matched?.viewValue || f.organizationName;

      }
    }

    // Gap logic
    if (f.hasGaps == true || f.hasGaps == 'true') {
      organizationName = 'Gap in work history';
    }

    const payload:any = {

      workHistoryId: this.isEditMode ? Number(this.editId) : null,

      credentialingEventId: credentialingEventId,

      organizationName: organizationName,
      other: f.other,
      address1: f.location,
      address2: '',
      city: f.city,
      state: f.state,
      zip: f.zip,

      phone: f.phone || null,

      startDate: this.datapipe.transform(f.startDate, 'MM-dd-yyyy'),
      endDate: this.datapipe.transform(f.endDate, 'MM-dd-yyyy'),

      gapExplanation: f.hasGaps ? f.gapExplanation : '',

      isSchool: this.checkForm.value.educationChecked,

      userId: userId,

      isDeleted: false,

      isLocationInDW: false,
      isCurrentlyWorking: this.stillWorkingForm.value.workingChecked
    };
    if (this.checkForm.get('educationChecked')?.value) {
      payload['country'] = f.country ? f.country : null
      payload['degree'] = f.degree ? f.degree : null
      //payload['educationType'] = f.educationType ? f.educationType : null
    }
    payload['degree'] = this.checkForm.get('educationChecked')?.value ? (f.degree || null) : null;
    payload['educationType'] = this.checkForm.get('educationChecked')?.value ? (f.educationType || 'DENTAL_SCHOOL') : null;
    // Get existing list
    let existingRaw = localStorage.getItem('workhistories') ? JSON.parse(localStorage.getItem('workhistories') || '[]') : [];


    let existing = this.toWorkHistoryDTOArray(existingRaw);
    
    existing = existing.map((obj: any) => {
      const copy = { ...obj };
      copy.userId = userId;
      if(typeof(copy['endDate']) == "number") {
      copy.endDate = this.formatDate(""+copy.endDate)
      }
      return copy;
    });

    let finalPayload;

    if (this.isEditMode) {

      finalPayload = existing.map((item: any) =>
        item.workHistoryId == this.editId ? payload : item
      );

    } else {

      finalPayload = [...existing, payload];

    }
    finalPayload = finalPayload.map((obj: any) => {
      return {
        ...obj,
        other: obj.other || ' '
      };
    })
    this.workHistoryService.saveToApi(finalPayload).subscribe((response) => {
      // Store the API response (not the finalPayload)
      localStorage.setItem('workhistories', JSON.stringify(response));

      // Navigate back to list
      this.router.navigate(['/credentialing/work-history']);

    });


  }
  private listenPhoneFormat() {
    const phoneControl = this.form.get('phone');
    phoneControl?.valueChanges.subscribe((val: string) => {

      if (!val) return;
      const digits = val?.replace(/\D/g, '');
      let formatted: any = '';
      if (digits.length > 0) {
        formatted += '(' + digits.substring(0, Math.min(3, digits.length));
      }
      if (digits.length >= 4) {
        formatted += ') ' + digits.substring(3, Math.min(6, digits.length));
      }
      if (digits.length >= 7) {
        formatted += '-' + digits.substring(6, 10);
      }
      if (val !== formatted) {
        phoneControl.setValue(formatted, { emitEvent: false });
      }
    })
  }

  onSchoolChange(event: any) {
    this.form.get('location')?.reset();
    this.form.get('city')?.reset();
    this.form.get('state')?.reset();
    this.form.get('zip')?.reset();
    this.form.get('phone')?.reset();
    const selectedName = event?.name ?? event?.viewValue ?? '';
    this.selectedSchoolFromDropDown = selectedName;

    const selectedId = event?.value || event;

    const schools = JSON.parse(localStorage.getItem('schoolswithAddresses') || '[]');

    const selectedSchool = schools.find((s: any) => s.Id == selectedId);

    const isOtherSchool =
    selectedName.toLowerCase() === 'my school is not listed' ||
    selectedName.toLowerCase() === 'other';

    if (selectedSchool && !isOtherSchool) {
      const current = this.form.value;
      this.form.patchValue({
        location: !current.location ? selectedSchool.location : current.location,
        city: !current.city ? selectedSchool.City : current.city,
        state: !current.state ? selectedSchool.State : current.state,
        zip: !current.zip ? selectedSchool.Zip : current.zip,
        phone: !current.phone ? selectedSchool.Phone : current.phone
      });

    }

    if (isOtherSchool) {
        this.form.get('other')?.enable();
        this.form.get('other')?.setValidators(Validators.required);
        this.form.get('other')?.updateValueAndValidity();
    } else {
        this.form.get('other')?.setValue('');
        this.form.get('other')?.clearValidators();
        this.form.get('other')?.disable();
        this.form.get('other')?.updateValueAndValidity();
    }
  }
  isNotesLimitExceeded(): boolean {
    const notes = this.form.get('gapExplanation')?.value || '';
    return notes.length > 600;
  }

  get gapExplanation(): FormControl {
    return this.form.get('gapExplanation') as FormControl;
  }

  formatDropDown(arr: any) {
    return arr.map((item: any) => ({
      value: item.Id,
      viewValue: item.Name
    }));
  }

  getSchools() {
    setTimeout(() => {
      let schools = localStorage.getItem('schoolswithAddresses');

      let schoolList: any[] = [];

      try {
        schoolList = schools ? JSON.parse(schools) : [];
      }
      catch {
      }
      if (schoolList.length > 0) {
        this.schoolsList = this.formatDropDown(schoolList);
        const hasOther = this.schoolsList.find(
          (s: any) => s.viewValue === 'My School Is Not Listed'
      );
      if (!hasOther) {
          this.schoolsList.push({ 
              value: 'other', 
              viewValue: 'My School Is Not Listed' 
          });
      }
      }
      setTimeout(() => {
        this.loader.hide();
      })
    })
  }

  toWorkHistoryDTOArray(payload: any[]): WorkHistoryDTO[] {
    return (payload ?? []).map(item => {
      const {
        workHistoryId,
        credentialingEventId,
        userId,
        organizationName,
        address1,
        address2,
        city,
        state,
        zip,
        phone,
        startDate,
        endDate,
        gapExplanation,
        isSchool,
        isDeleted,
        isLocationInDW,
        other,
        isCurrentlyWorking
      } = item ?? {};

      return {
        workHistoryId: workHistoryId ?? null,
        credentialingEventId: credentialingEventId ? credentialingEventId :  Number(localStorage.getItem('credentialingEventId')) ?? null,
        userId: userId ?? null,
        organizationName: organizationName ?? null,
        address1: address1 ?? null,
        address2: address2 ?? '',
        city: city ?? null,
        state: state ?? null,
        zip: zip ?? null,
        phone: phone ?? null,
        startDate: startDate ?? null,
        endDate: endDate ?endDate: null,
        gapExplanation: gapExplanation ?? null,
        isSchool: Boolean(isSchool),
        isDeleted: Boolean(isDeleted),
        isLocationInDW: Boolean(isLocationInDW),
        other: other ?? null,
        isCurrentlyWorking: isCurrentlyWorking?? false
      };
    });
  }

  formatToMMDDYYYY(dateStr: string): string {
    if (!dateStr) return '';
    const mmddyyyyRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-\d{4}$/;
    if (mmddyyyyRegex.test(dateStr)) {
      return dateStr;
    }
    const yyyymmddRegex = /^\d{8}$/;
    if (yyyymmddRegex.test(dateStr)) {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${month}-${day}-${year}`;
    }
    const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (isoRegex.test(dateStr)) {
      const [year, month, day] = dateStr.split('-');
      return `${month}-${day}-${year}`;
    }
    return dateStr;
  }
   
  onGapsChange() {
    const hasGap = this.hasGapsGroup.get('hasGaps')?.value === 'true' || this.hasGapsGroup.get('hasGaps')?.value === true;

    if (hasGap) {
      this.form.get('gapExplanation')?.setValidators([Validators.required]);
      this.form.get('startDate')?.setValidators([Validators.required]);
      this.form.get('endDate')?.setValidators([Validators.required]);
      this.form.get('startDate')?.setValidators([Validators.required, dateNotInFutureValidator]);
      this.form.get('endDate')?.setValidators([Validators.required, this.endDateAfterStartValidator, dateNotInFutureValidator]);      
    } else {
      if (this.form.get('organizationName')?.value?.toLowerCase() == "gap in work history") {
        this.form.get('organizationName')?.setValue('');
      }
      this.form.get('gapExplanation')?.clearValidators();
      this.form.get('gapExplanation')?.setValue('');
      this.form.get('startDate')?.setValidators([Validators.required, dateNotInFutureValidator]);
      this.form.get('endDate')?.setValidators([Validators.required, this.endDateAfterStartValidator, dateNotInFutureValidator]);      
    }
    this.form.get('startDate')?.updateValueAndValidity();
    this.form.get('endDate')?.updateValueAndValidity();
    this.form.get('gapExplanation')?.updateValueAndValidity();
  }
  formatDate(dateString: string): string {
    if (!dateString || dateString?.length !== 8) return "";
   
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
   
    return `${month}/${day}/${year}`;
  }

  onStillWorking(event:any){
    if(event.target.checked){
      this.form.get('endDate')?.removeValidators(Validators.required)
    }else{
      this.form.get('endDate')?.setValidators(Validators.required)
    }
    this.form.get('endDate')?.updateValueAndValidity();
  }
    onLocationChange(val: any) {
    $('.pac-container').addClass('hide');
    if (val.length > 0) { this.showError = false }
  }
  async onFocus()
  {
    $('.pac-container').addClass('hide');
    await this.repositionDropdown();
  }
  async repositionDropdown() {
  
    const input = this.locationInputs.get(0)?.nativeElement;
    const pacContainer = document.querySelector('.pac-container') as HTMLElement;
 
    if (pacContainer && input) {
      // Style positioning
      
      pacContainer.style.position = 'absolute';
      const rect = this.locationInputs.get(0)?.nativeElement.getBoundingClientRect();
      pacContainer.style.top = `${rect.bottom + window.scrollY}px`;
      pacContainer.style.left = `${rect.left}px`;
      pacContainer.style.width = `${rect.width}px`;
    }
    
  }
 
  async onScroll() {
   $('.pac-container').addClass('hide');
  }
  async ngAfterViewInit() {
    if ((window as any).google) {
      await this.initializeAutoComplete();
    }
    else {
      const interval = setInterval(async () => {
        if ((window as any).google) {
          clearInterval(interval);
          await this.initializeAutoComplete();
         }
      }, 300)
    }
    //
    this.locationInputs.changes.subscribe(async () => {
      $('.pac-container').addClass('hide');
     await this.initializeAutoComplete();
    }) 
  }
  async initializeAutoComplete() {
    const visibleInputs = this.locationInputs.filter(
      (inputRef: ElementRef) =>
        !!inputRef.nativeElement.offsetParent
    )
    visibleInputs.forEach((inputRef) => {
      const autoComplete = new (window as any).google.maps.places.Autocomplete(
        inputRef.nativeElement, { types: ['address'],
          componentRestrictions: { country: 'us' } }
      );
     
      const autoCompleteService = new google.maps.places.AutocompleteService()
      
      autoComplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place = autoComplete.getPlace();
          if (place && place.formatted_address) {
            this.showError = false;
            this.selectedAddress = place.formatted_address || '';
            this.isPlaceSelected = true;
            let homeAddress = '';
            let city = '';
            let state = '';
            let zip = '';
            let streetNumber = '';
            let route = '';
            place.address_components?.forEach((component: any) => {
 
              // Street Number
              if (component.types.includes('street_number')) {
                streetNumber = component.long_name;
              }
      
              // Street Name
              if (component.types.includes('route')) {
                route = component.long_name;
              }
              // City
              if (!city && component.types.includes('locality')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('postal_town')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('sublocality')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('administrative_area_level_2')) {
                city = component.long_name;
              }
       
              // State
              if (component.types.includes('administrative_area_level_1')) {
                state = component.short_name;
              }
       
              // ZIP
              if (component.types.includes('postal_code')) {
                zip = component.long_name;
              }
            });
        
            // Build address line
            homeAddress = `${streetNumber} ${route}`.trim();
            this.form.patchValue(({
              "location" : homeAddress
            }))
            this.form.patchValue(({
              "city" : city
            }))
            this.form.patchValue(({
              "state" : state
            }))
            this.form.patchValue(({
              "zip" : zip
            }))
            if(!zip){
              this.showFulladdressError = true
            }else{
              this.showFulladdressError = false
            }
            this.validateLocation(this.selectedAddress);
          }
        })
      })

      inputRef.nativeElement.addEventListener('input', (e: any) => {
        this.isPlaceSelected = false;
        const value = e.target.value;

        if (!value) {
          this.suggestionCount = 0;
          return;
        }
        autoCompleteService.getPlacePredictions(
          { input: value, types: ['address'],
            componentRestrictions: { country: 'us' } },
          (predictions, status) => {
            this.ngZone.run(async () => {
              if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
                await this.repositionDropdown();
                $('.pac-container').removeClass('hide');
                this.suggestionCount = predictions.length;
              }
              else {
                this.suggestionCount = 0;
              }
            })
          }
        )
      })
      const input = inputRef.nativeElement;
      input.setAttribute('placeholder', 'Type work/school address')
    })
  // Listen to scroll events (both page & nested containers)

  window.addEventListener('scroll', this.scrollHandler, true);
  window.addEventListener('touchmove', this.scrollHandler, true);
   
 }
 ngOnDestroy() {
   window.removeEventListener('scroll', this.scrollHandler, true);
   window.removeEventListener('touchmove', this.scrollHandler, true);
 }
 validateLocation(inputText: string): Promise<boolean> {
  return new Promise((resolve) => {
    if (!this.isPlaceSelected && (!inputText || inputText.trim().length < 3)) {
      resolve(false);
      return;
    }
    if (!this.isPlaceSelected && (!inputText || inputText.trim().length == 3)) {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: inputText }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const valid = results.some((r: any) =>
            r.types.includes('locality') || r.types.includes('administrative_area_level_1') || r.types.includes('country')
          )
          resolve(valid);
        }
        else {
          resolve(false);
        }
      })
      return;
    }
    const service = new google.maps.places.AutocompleteService();
    service.getPlacePredictions({ input: inputText }, (predictions: any, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
        resolve(true);
        return;
      }
      else {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: inputText }, (results: any, status: any) => {
          if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
            resolve(true);
          }
          else {
            resolve(false);
          }
        })
      }
    })

  })
}
}
